import { SupplierProductRuleXrefLite as FormularyXref } from '@absg/api-formulary';
import { RuleLite as ContainerXref } from '@absg/api-station-management';
import { RuleHelper } from '@absg/nim-client-shared';

export class SettingsEngine {
  // Returns if there is an xref or not for a given rule from station api
  static determineSettingFromContainer(xref: ContainerXref, stationDefault: string): string {
    if (xref != null && xref.xrefValue != null) {
      return xref.xrefValue;
    }
    return stationDefault;
  }

  // Returns if there is an xref or not for a given rule from formulary api
  static determineSettingFromFormulary(xref: FormularyXref, formularyDefault: string): string {
    if (xref != null && xref.value != null) {
      return xref.value;
    }
    return formularyDefault;
  }

  // Finds the Property setting for an Item. If not assigned we should pass a null in positionRuleSetting
  static determinePropertySetting(
    stationSetting: string,
    positionRuleSetting: ContainerXref,
    formularyRuleSetting: FormularyXref,
    formularyDefault: string,
  ): boolean {
    // If station says NO, then setting is off
    if (!RuleHelper.getBooleanFromText(stationSetting)) {
      return false;
    }

    // If you have a position setting it uses that (If unassigned this will be null)
    if (positionRuleSetting && positionRuleSetting.xrefValue) {
      return RuleHelper.getBooleanFromText(positionRuleSetting.xrefValue);
    }

    // If there is a formulary setting(Currently from Practice Formulary) use that.
    if (formularyRuleSetting && formularyRuleSetting.value) {
      return RuleHelper.getBooleanFromText(formularyRuleSetting.value);
    }

    return RuleHelper.getBooleanFromText(formularyDefault);
  }

  // Finds lot tracking Setting for an Item
  static determineLotTrackingSetting(
    stationRule: ContainerXref,
    positionRuleSetting: ContainerXref,
    stationDefault: string,
  ): boolean {
    const positionValue = positionRuleSetting && positionRuleSetting.xrefValue;
    const stationValue = stationRule && stationRule.xrefValue;
    // If you have a position setting it uses that (If unassigned this will be null)
    if (positionValue) {
      return RuleHelper.getBooleanFromText(positionValue);
    }
    // If station setting available, use station
    if (stationValue) {
      return RuleHelper.getBooleanFromText(stationRule.xrefValue);
    }
    // If no changes, use the default value.
    return RuleHelper.getBooleanFromText(stationDefault);
  }
}
